import { ComponentType, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../store/hooks';
import { SnackBarContext } from '../../../../../../shared/components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../../../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { useCheckPath } from '../../../../../../shared/hooks/use-check-path/use-check-path.hook';
import { useSnackbarContextState } from '../../../../../../shared/hooks/use-snack-bar-context-state/use-snackbar-context-state.hook';
import { OuterVehiclePopulationFormPropsModel } from '../../../models/outer-vehicle-population-form-props.model';
import { WithVehiclePopulationDataProps } from '../../../types/with-vehicle-population-data.props';

const withCreateCampaignFormData = <
  TProps extends OuterVehiclePopulationFormPropsModel
>(
  WrappedComponent: ComponentType<TProps>
): ((props: Omit<TProps, WithVehiclePopulationDataProps>) => JSX.Element) => {
  return (props: Omit<TProps, WithVehiclePopulationDataProps>) => {
    const vehiclePopulationFormState = useAppSelector(
      state => state.campaignsFeature.vehiclePopulation.data
    );

    const basicInfoFormState = useAppSelector(
      state => state.campaignsFeature.basicInfo.data
    );

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [isOnEdit, { id: campaignId }] = useCheckPath(
      '/campaign-management/edit/'
    );

    const snackbarCtx = useContext(SnackBarContext) as SnackBarContextModel;
    const snackBarConfig = useSnackbarContextState();

    return (
      <WrappedComponent
        {...(props as TProps)}
        vehiclePopulationStateFields={vehiclePopulationFormState}
        basicInfoStateFields={basicInfoFormState}
        dispatch={dispatch}
        navigate={navigate}
        isOnEdit={isOnEdit}
        campaignId={campaignId}
        snackbarCtx={snackbarCtx}
        snackBarConfig={snackBarConfig}
      />
    );
  };
};

export default withCreateCampaignFormData;
